import {
	BlueprintInfo,
	createBlueprint,
	CreateBlueprintInfo,
	getBlueprintContent,
	updateBlueprintContent
} from "core/blueprint/base/BlueprintService";
import { Operation } from "rfc6902/diff";
import { get } from "utils/Service";

const ENDPOINT = "/api/blueprints/extracts";

const EXTRACT_SUFFIX = "extracts";

// @Deprecated
export function getExtractBlueprints(): Promise<BlueprintInfo[]> {
	return get(ENDPOINT).then(response => response.json());
}

export function createExtractBlueprint(
	info: CreateBlueprintInfo
): Promise<string> {
	return createBlueprint(EXTRACT_SUFFIX, info);
}

// TODO: proper type.
export function getExtractBlueprintContent(id: number): Promise<unknown> {
	return getBlueprintContent<unknown>(EXTRACT_SUFFIX, id);
}

export function updateExtractBlueprintContent(
	id: number,
	content: Operation[]
): Promise<void> {
	return updateBlueprintContent(EXTRACT_SUFFIX, id, content);
}
